
import { Typography, Box, ListItemButton, ListItemText, Divider, ListSubheader, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { apiResult, getUserSession, } from "../../../Utils/Common";
import IconButton from "@mui/material/IconButton/IconButton";
import {  ListAltOutlined, ReceiptLongOutlined, Remove, } from "@mui/icons-material";
import apis from "../../../api";
import { getItemsFromObjects } from "../../../Component/DataLoader";
import { MemberItem } from "../../member/fragement/MemberItems";

const ClassMembers = (props) => {
    const { onError, classMembers,courses, title, sx, onClick, selected,onRemove } = props
    const [datas, setDatas] = useState()
    const [curIdx1, setCurIdx] = useState()
    const [clickItem, setClickItem] = useState()
    getUserSession(apis)
    useEffect(() => {
        setDatas(classMembers)
    }, [classMembers])
    useEffect(() => {
        setClickItem(selected)
    }, [selected])

    const handleDelete = (idx, item) => {
        window.confirm("Are you sure to remove the member from the class?") && apis.classmemberDelete(item.id).then(ret => {
            apiResult(ret, data => {
                let cc = [...datas]
                cc.splice(idx,1)
                setDatas(cc)
                onRemove && onRemove(idx)
            }, onError)
        })
    }

    const handleMouseOver = (idx) => {
        setCurIdx(idx)
    }
    
    const handlClickItem = (idx1,item)=>{
        if(clickItem?.member_id == item.member?.id && clickItem?.member_course_id == item.member_course.id) {
            setClickItem()
            onClick && onClick()
        }else {
            setClickItem({member_id:item.member?.id,member_course_id:item.member_course.id})
            onClick && onClick({member_id:item.member?.id,member_course_id:item.member_course.id,member:item.member,member_course:item.member_course})
        }
    }
    const handleOrderView = (idx, item) => {
        window.open('/member/course/' + item.member?.id+"/"+item.member_course?.course_package?.category_id,"order")
    }
    const handleBillView = (idx, item) => {
        window.open('/member/balancelog/' + item.member.user_id + "/0","bill")
    }
    
    return datas && <Box sx={{ ...sx, border: "1px solid #8882" }}>
        {title && <ListSubheader component="div">{title} ({datas.length})</ListSubheader>}
        {datas.map((item, idx1) => {
            let ccid = item.member_course?.course_package?.course_id
            let rr = item.member_course?.remained
            
            let billtype = item.member_course?.course_package?.billtype
            let minutes = item.member_course?.course_package?.minutes
            rr = billtype == 0?rr:(rr/60).toFixed(1)            
            let lessons = billtype == 0 ? (rr + " lessons (" + (minutes / 60).toFixed(1) + " h)") : (rr + " hours")            
            lessons = <font color={rr == 0?"red":(rr<3?"orange":"gray")}>{lessons}</font>
            let cc = ccid > 0 && getItemsFromObjects(courses, ccid)
            return <Box key={idx1} ><ListItemButton selected={clickItem?.member_id == item.member?.id && clickItem?.member_course_id == item.member_course?.id} onClick={() => handlClickItem(idx1, item)} onMouseEnter={() => { handleMouseOver(idx1) }}>
                
                <ListItemText primary={
                    <Box sx={{display:"flex"}}>
                        <MemberItem member={item.member} sx={{mt:0.5,mr:0.5}}/>
                        {idx1 == curIdx1 && <Tooltip title="Course orders"><IconButton size="small" onClick={()=>{handleOrderView(idx1,item)}}><ListAltOutlined fontSize="inherit" /></IconButton></Tooltip>}
                        {idx1 == curIdx1 && <Tooltip title="Transaction logs"><IconButton size="small" onClick={()=>{handleBillView(idx1,item)}}><ReceiptLongOutlined fontSize="inherit" /></IconButton></Tooltip>}
                    </Box>}
                    secondary={<Typography sx={{ color: "gray", fontSize: '12px' }}>{cc?.name} / {lessons}</Typography>}
                />
                {idx1 == curIdx1 && <IconButton aria-label="Add" size="small" onClick={() => { handleDelete(idx1, item) }}><Remove fontSize="inherit" /></IconButton>}
            </ListItemButton>
                <Divider />
            </Box>
        })}
        {/* <RightDrawer toggleDrawer={handleRightDrawer} open={rightDrawer ? true : false}>
            {rightDrawer}
        </RightDrawer> */}
    </Box>
}
export default ClassMembers